import React, { useEffect, useRef, useState } from 'react';
import { Text } from '@cuemath/web-comps';
import { SORT_OPTIONS, DEFAULT_SORT } from '../../constants';
import { SA_COLORS } from '../../styled-comps';
import {
  SortWrap,
  SortBtn,
  SortDot,
  SortMenu,
  SortMenuHeader,
  SortMenuItem,
} from './styled';
import Icon from '../icon';

const SortControl = ({ value, onChange }) => {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const handler = e => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  const active = SORT_OPTIONS.find(o => o.value === value) || DEFAULT_SORT;
  const isDefault = active.value === DEFAULT_SORT.value;

  const handlePick = option => {
    setOpen(false);
    if (option.value !== value) onChange(option);
  };

  return (
    <SortWrap ref={wrapRef}>
      <SortBtn
        $active={!isDefault}
        title={`Sort: ${active.label}`}
        onClick={() => setOpen(prev => !prev)}
      >
        <Icon name="sort" size={14} />
        {!isDefault && <SortDot />}
      </SortBtn>
      {open && (
        <SortMenu>
          <SortMenuHeader>
            <Text variant="body3" weight={600} color={SA_COLORS.TEXT_TERTIARY}>
              SORT TICKETS BY
            </Text>
          </SortMenuHeader>
          {SORT_OPTIONS.map(option => (
            <SortMenuItem
              key={option.value}
              $active={option.value === active.value}
              onClick={() => handlePick(option)}
            >
              <Text variant="body2">{option.label}</Text>
              {option.value === active.value && <Icon name="check" size={14} />}
            </SortMenuItem>
          ))}
        </SortMenu>
      )}
    </SortWrap>
  );
};

export default SortControl;
